<template>
  <div class="setting-container">
    <el-tabs tab-position="left" class="setting-tabs">
      <el-tab-pane label="提交设置">
        <submit-setting />
      </el-tab-pane>
      <el-tab-pane label="回收设置">
        <write-setting />
      </el-tab-pane>
      <el-tab-pane label="通知设置">
        <notify-setting />
      </el-tab-pane>
      <el-tab-pane label="分享设置">
        <share-setting />
      </el-tab-pane>
      <el-tab-pane label="页面设置">
        <div class="project-setting-view">
          <p class="project-setting-title">
            页面设置
            <span class="small-font-size ml20 text-secondary-color"> 问卷填写时题目的交互方式 </span>
          </p>
          <el-divider />
          <el-form ref="pageSettingForm" :model="pageSettingForm" @submit.native.prevent>
            <div class="setting-item">
              <p class="label" style="width: 30%">页面交互方式</p>
              <el-radio-group v-model="pageSettingForm.pageShowType" v-removeAriaHidden>
                <el-radio label="more"> 一页多题 </el-radio>
                <el-radio label="single"> 一页一题 </el-radio>
              </el-radio-group>
            </div>
            <div class="submit-btn">
              <el-button type="primary" @click="saveSettingHandle"> 保存设置 </el-button>
            </div>
          </el-form>
        </div>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>
<script>
import SubmitSetting from './submit'
import WriteSetting from './write'
import NotifySetting from './notify'
import ShareSetting from './share'
import mixin from './mixin'
import { getSettingRequest, saveSettingRequest } from '../../../api/project/setting'

export default {
  name: 'ProjectSetting',
  mixins: [mixin],
  components: {
    SubmitSetting,
    WriteSetting,
    NotifySetting,
    ShareSetting
  },
  data() {
    return {
      pageSettingForm: {
        pageShowType: 'more'
      }
    }
  },
  mounted() {
    this.queryUserProjectSetting()
  },
  methods: {
    uploadSubmitPromptHandle(response) {
      this.pageSettingForm.promptImgUrl = response.data
    },
    queryUserProjectSetting() {
      getSettingRequest(this.formKey).then((res) => {
        if (res.data) {
          this.pageSettingForm = res.data
        }
      })
    },
    saveSettingHandle() {
      this.$refs['pageSettingForm'].validate((valid) => {
        if (valid) {
          this.pageSettingForm.formKey = this.formKey
          saveSettingRequest(this.pageSettingForm).then(() => {
            this.msgSuccess('保存成功')
            this.queryUserProjectSetting()
          })
        } else {
          return false
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
@import 'settting';
.setting-container {
  width: 100%;
  background-color: var(--color-bg);
  display: flex;
  justify-content: center;

  .setting-tabs {
    border-radius: 8px;
    margin-top: 20px;
    width: 900px;
    min-height: 500px;
  }
}

::v-deep.el-tabs--left .el-tabs__nav-wrap.is-left::after {
  width: 0;
}

::v-deep.el-tabs--left .el-tabs__nav.is-left,
.el-tabs--left .el-tabs__nav.is-right,
.el-tabs--right .el-tabs__nav.is-left,
.el-tabs--right .el-tabs__nav.is-right {
  background-color: #ffffff !important;
  //box-shadow: 0 2px 4px rgba(0, 0, 0, .12), 0 0 6px rgba(0, 0, 0, .04) !important;
}
</style>
